// Copyright (c) 2021, Comsearch, Inc., All rights reserved

import React from 'react'
import { warning } from 'react-notification-system-redux'

const handleWarning = (uid, message) => dispatch => {
  const warningUID = `${uid}-warning`

  dispatch(warning({
    uid: warningUID,
    title: 'Warning:',
    autoDismiss: 0,
    children: (
      <span id={warningUID}>
        {message}
      </span>
    ),
  }))
}

export default handleWarning
